import { isNil } from "lodash";

const SORT_ICON_CLASSNAMES =
    "text-xs ml-1.5 text-text-300/55 opacity-0 transition-opacity duration-[120ms] ease-in-out [.p-sortable-column.p-highlight_&]:opacity-100 [.p-sortable-column.p-highlight_&]:text-primary-600 [.p-sortable-column:hover_&]:opacity-100 [.p-sortable-column:focus-visible_&]:opacity-100";

export interface IconSortProps {
    sorted?: boolean;
    sortOrder?: number | null;
}

const IconSort = (props: IconSortProps) => {
    const { sorted, sortOrder } = props;

    if (sorted && !isNil(sortOrder) && sortOrder < 0) {
        return (
            <i
                className={`pi pi-sort-amount-down ${SORT_ICON_CLASSNAMES}`}
                aria-hidden="true"
            />
        );
    }

    return (
        <i
            className={`pi pi-sort-amount-down-alt ${SORT_ICON_CLASSNAMES}`}
            aria-hidden="true"
        />
    );
};

export default IconSort;
